
import { useContext } from "react";
import AddItem from "./components/AddItem";
import ItemsList from "./components/ItemsList";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Register from "./components/Register";
import { ItemsContext } from "./contexts/ItemsContext";
import Welcome from "./components/Welcome";
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Presentation from "./components/Presentation";
import Logo from "./components/Logo";


function App() {

  const {loggedInUser,login,signup,presentation}=useContext(ItemsContext)

  return (
    <div className="App">

            {presentation && !login && !signup && !loggedInUser && <Presentation />}
            {!presentation && !login && !signup && !loggedInUser && <Welcome />}
            {login && !loggedInUser && !signup && <Login />}
            {signup && !loggedInUser && !login && <Register />}
              
            
             { loggedInUser && (
              <div className="main">  
                  <Logout />
                    <div className="app" id="top">
                      <ItemsList />
                      <AddItem />  
                    </div>

                        <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                        style={{ position: 'fixed', top: '74px', right: '50px', transform: "scale(1.1)" }}
                        />
</div>
            ) 
            }
        
          
        
     
         <Logo/>
        <p id="copyright">© 2023 Marek Loníček</p>  
         
      
    </div>
  );
}

export default App;
